export const COACHING_PROMPTS = [
  {
    id: 'comp_1',
    category: 'Comprehension',
    why: 'Prediction builds verbal reasoning — one of the strongest predictors of long-term reading success.',
    text: 'Ask your child: "What do you think happens next in the story? Why?"'
  },
  {
    id: 'comp_2',
    category: 'Comprehension',
    why: 'Perspective-taking grows comprehension and empathy at the same time.',
    text: '"What would you do if you were the main character? Tell me more!"'
  },
  {
    id: 'comp_3',
    category: 'Comprehension',
    why: 'Retelling in their own words is the strongest indicator of true reading comprehension.',
    text: '"Can you retell the story in your own words? What was your favorite part?"'
  },
  {
    id: 'vocab_1',
    category: 'Vocabulary',
    why: 'Acting out a word physically locks it into long-term memory far better than reading it.',
    text: `Pick a new word from today's session. Ask: "What does it mean to you? Can you act it out?"`
  },
  {
    id: 'vocab_2',
    category: 'Vocabulary',
    why: 'Connecting new words to personal experience is how vocabulary sticks.',
    text: '"Have you ever felt like the character did today? When?"'
  },
  {
    id: 'vocab_3',
    category: 'Vocabulary',
    why: 'Building word webs expands vocabulary faster than definitions alone.',
    text: `Ask: "Can you think of three other words that mean something similar? Let's make a list!"`
  },
  {
    id: 'phonics_1',
    category: 'Phonics',
    why: 'Reading aloud together reinforces the sound-letter connections Finley is building right now.',
    text: `Point to a word on screen together. Say: "Let's sound it out — what sound does each letter make?"`
  },
  {
    id: 'phonics_2',
    category: 'Phonics',
    why: 'Rhyme games build phonemic awareness — the foundation of all decoding.',
    text: `"Find a word that rhymes with [a word from today's session] — let's make a silly rhyme list!"`
  },
  {
    id: 'phonics_3',
    category: 'Phonics',
    why: "Spelling out loud strengthens the brain's letter-sound mapping pathway.",
    text: 'Pick any word from today. Say: "Can you spell it out loud while I tap each letter?"'
  },
  {
    id: 'motivation_1',
    category: 'Motivation',
    why: 'Noticing positive emotion after reading builds a lifelong association between reading and joy.',
    text: '"What part made you smile or feel excited today? Why?"'
  },
  {
    id: 'motivation_2',
    category: 'Motivation',
    why: 'Drawing or acting out scenes strengthens comprehension and makes sessions memorable.',
    text: '"Draw or act out your favorite scene from today — ready, set, go!"'
  },
  {
    id: 'motivation_3',
    category: 'Motivation',
    why: 'Celebrating specific effort (not just results) builds reading confidence.',
    text: 'Tell your child one specific thing they did really well today. Be specific — not just "great job!"'
  }
];

const LAST_IDX_KEY = 'rq:coaching:lastIdx';
const DONE_COUNT_KEY = 'rq:coaching:done';

export function getNextCoachingPrompt() {
  if (!COACHING_PROMPTS.length) return null;
  let lastIdx = -1;
  try {
    const raw = localStorage.getItem(LAST_IDX_KEY);
    if (raw != null) {
      const parsed = Number.parseInt(raw, 10);
      if (Number.isFinite(parsed)) lastIdx = parsed;
    }
  } catch {}
  const nextIdx = (lastIdx + 1) % COACHING_PROMPTS.length;
  try {
    localStorage.setItem(LAST_IDX_KEY, String(nextIdx));
  } catch {}
  return COACHING_PROMPTS[nextIdx];
}

export function logCoachingDone() {
  let count = 0;
  try {
    const raw = localStorage.getItem(DONE_COUNT_KEY);
    if (raw != null) {
      const parsed = Number.parseInt(raw, 10);
      if (Number.isFinite(parsed)) count = parsed;
    }
  } catch {}
  try {
    localStorage.setItem(DONE_COUNT_KEY, String(count + 1));
  } catch {}
}
